import { FC } from "react";
import { MDSIcon, MDSIconKind } from "@/mds/components/icon";
import { MDSLoadingSpinnerProps } from "./loading-spinner.types";
import { StyledLoadingSpinner } from "./loading-spinner.styles";

export const MDSLoadingSpinner: FC<MDSLoadingSpinnerProps> = ({ size = 16, color }) => {
  return (
    <StyledLoadingSpinner>
      <MDSIcon kind={MDSIconKind.SpinnerThird} size={size} boxSize={size} color={color} />
    </StyledLoadingSpinner>
  );
};
